import { constant } from "es-toolkit/compat";
import { Component } from "react";

// NOTE: this component is only used by <PhoneWatchVideo>, it basically disables (sets to auto)
// a CSS property `-webkit-overflow-scrolling` on ReactModal, which happens to make <CastControl>
// not to render properly on iOS, possibly due to some stacking issue in RMP (Radiant Media Player)

type HTMLElementWithWebkitOverflowScrolling = Omit<HTMLElement, "style"> & {
  style: HTMLElement["style"] & { webkitOverflowScrolling: string };
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class NoWebkitOverflowScrolling extends Component {
  componentDidMount() {
    this.modal = document.querySelector<HTMLElementWithWebkitOverflowScrolling>(".ReactModal__Content");

    if (this.modal && this.modal.style.webkitOverflowScrolling) {
      this.webkitOverflowScrolling = this.modal.style.webkitOverflowScrolling;
      this.modal.style.webkitOverflowScrolling = "auto";
    }
  }

  componentWillUnmount() {
    if (this.modal && this.webkitOverflowScrolling) {
      this.modal.style.webkitOverflowScrolling = this.webkitOverflowScrolling;
    }
  }

  render = constant(null);

  modal: HTMLElementWithWebkitOverflowScrolling | null | undefined;
  webkitOverflowScrolling: string | undefined;
}
